<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="reports"
      :search="search"
      disable-pagination
      hide-default-footer
      :expanded.sync="expanded"
      item-key="doId"
      show-expand
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-row class="mt-2">
            <v-col cols="12" sm="12" md="8" lg="8">
              <v-text-field
                flat
                dense
                outlined
                v-model="search"
                placeholder="Search"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-toolbar>
      </template>
      <template v-slot:item.no="{ index }">
        {{ index + 1 }}
      </template>
      <template v-slot:item.totalDo="{ item }">
        {{ formatPrice(totalDo(item.productCustomers)) }}
      </template>
      <template v-slot:item.totalAmount="{ item }">
        {{ formatPrice(item.totalAmount) }}
      </template>
      <template v-slot:item.hasProductInternal="{ item }">
        {{ item.productInternals.length > 0 ? "Ada" : "Tidak Ada" }}
      </template>
      <template v-slot:item.hasBomList="{ item }">
        {{ item.hasBomList ? "Ada" : "Tidak Ada" }}
      </template>
      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length">
          <v-row>
            <v-col cols="12">PRODUCT DO</v-col>
            <v-col cols="12">
              <v-simple-table dense>
                <thead>
                  <tr>
                    <th>No</th>
                    <th>Part#</th>
                    <th>Part Desc</th>
                    <th>Qty</th>
                    <th>Unit Price</th>
                    <th>Total</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(data, index) in item.productCustomers" :key="index + 'a'">
                    <td>{{ index + 1 }}</td>
                    <td>{{ data.partNumber }}</td>
                    <td>{{ data.partDesc }}</td>
                    <td>{{ data.qty }}</td>
                    <td>{{ formatPrice(data.unitPrice) }}</td>
                    <td>{{ formatPrice(data.qty * data.unitPrice) }}</td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-col>
            <v-col cols="12">PRODUCT INTERNAL DO</v-col>
            <v-col cols="12">
              <v-simple-table dense>
                <thead>
                  <tr>
                    <th>No</th>
                    <th>Part#</th>
                    <th>Part Desc</th>
                    <th>Qty</th>
                    <th>Total</th>
                    <th>BOM</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(data, index) in item.productInternals" :key="index + 'c'">
                    <td>{{ index + 1 }}</td>
                    <td>{{ data.partNumber }}</td>
                    <td>{{ data.partDesc }}</td>
                    <td>{{ data.qty }}</td>
                    <td>{{ formatPrice(data.total) }}</td>
                    <td>
                      <v-btn
                        class="mr-2"
                        color="success"
                        @click.prevent="openBomList(data.items, true)"
                        ><v-icon>mdi-magnify</v-icon></v-btn
                      ><v-btn
                        color="primary"
                        @click.prevent="openHoProduct(data.productId, data.poId, false)"
                        ><v-icon>mdi-eye</v-icon></v-btn
                      >
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-col>
          </v-row>
        </td>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">
          Reset
        </v-btn>
      </template>
    </v-data-table>
    <v-dialog v-model="dialog" max-width="1200" persistent>
      <v-card v-if="bom">
        <v-card-title>
          <span class="headline">BOM List</span>
        </v-card-title>
        <v-card-text>
          <detail-bom-list :items="items"></detail-bom-list>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" @click="close">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
      <v-card v-else>
        <v-card-title>
          <span class="headline">HO Product</span>
        </v-card-title>
        <v-card-text>
          <detail-ho-product :item="product"></detail-ho-product>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" @click="close">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import DetailBomList from "../inventory/hpp/DetailBomList.vue";
import DetailHoProduct from "../inventory/hpp/DetailHoProduct.vue";

export default {
  name: "po-outstanding",
  components: {
    DetailBomList,
    DetailHoProduct,
  },
  data: () => ({
    search: "",
    items: [],
    reports: [],
    product: {},
    dialog: false,
    bom: false,
    expanded: [],
    headers: [
      {
        id: 1,
        text: "No",
        value: "no",
        divider: true,
        sortable: false,
        class: "light-blue lighten-2 font-weight-black",
      },
      {
        id: 2,
        text: "Customer",
        value: "customerName",
        divider: true,
        sortable: false,
        class: "light-blue lighten-2 font-weight-black",
      },
      {
        id: 3,
        text: "DO#",
        value: "doNumber",
        divider: true,
        sortable: false,
        class: "light-blue lighten-2 font-weight-black",
      },
      {
        id: 3,
        text: "PO#",
        value: "poNumber",
        divider: true,
        sortable: false,
        class: "light-blue lighten-2 font-weight-black",
      },
      {
        id: 3,
        text: "RFS#",
        value: "rfsNumber",
        divider: true,
        sortable: false,
        class: "light-blue lighten-2 font-weight-black",
      },
      {
        id: 3,
        text: "Total DO",
        value: "totalDo",
        divider: true,
        sortable: false,
        class: "light-blue lighten-2 font-weight-black",
      },
      {
        id: 3,
        text: "Total HPP",
        value: "totalAmount",
        divider: true,
        sortable: false,
        class: "light-blue lighten-2 font-weight-black",
      },
      {
        id: 3,
        text: "Product Internal",
        value: "hasProductInternal",
        divider: true,
        sortable: false,
        class: "light-blue lighten-2 font-weight-black",
      },
      {
        id: 3,
        text: "BOM",
        value: "hasBomList",
        divider: true,
        sortable: false,
        class: "light-blue lighten-2 font-weight-black",
      },
      {
        id: 3,
        text: "Product Only",
        value: "countProductOnly",
        divider: true,
        sortable: false,
        class: "light-blue lighten-2 font-weight-black",
      },
    ],
  }),

  created() {
    this.initialize();
  },

  methods: {
    async initialize() {
      this.$store.commit("SET_LOADER", true);
      await this.$store
        .dispatch("report/getDoOutstanding")
        .then(response => {
          this.reports = response.data;
          this.$store.commit("SET_LOADER", false);
        })
        .catch(() => {
          this.$store.dispatch("toast", {
            type: "error",
            message: "Ada masalah dengan aplikasi, mohon hubungi admin aplikasi",
          });
          this.$store.commit("SET_LOADER", false);
        });
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    openBomList(items, bom) {
      this.bom = bom;
      this.items = items;
      this.dialog = true;
    },
    close() {
      this.dialog = false;
    },
    async openHoProduct(productId, poId, bom) {
      this.bom = bom;
      await this.$store
        .dispatch("inventory/getItemHo", { productId: productId, poId: poId })
        .then(response => {
          this.product = response.data;
          this.dialog = true;
        });
    },
    totalDo(items) {
      if (items.length > 0) {
        return items.map(x => x.qty * x.unitPrice).reduce((total, num) => total + num);
      }
      return 0;
    },
  },
};
</script>

<style></style>
